import React, { useState, useEffect, useContext } from 'react'
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import ListGroup from 'react-bootstrap/ListGroup';
import { ObjModal } from '../../../../contexts';
import SectionV2 from '../../Details/Section/v2';
import { styled } from '@mui/material/styles';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import KeyboardArrowRightSharpIcon from '@mui/icons-material/KeyboardArrowRightSharp';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import Section from '../../Details/Section';



const ObjFields = ( { aid, uid, title, body } ) => {
    const { objType, obj, openModal, closeModal, setModal } = useContext( ObjModal );
    const [ expanded, setExpanded ] = useState( true );

    const handleModal = ( t ) => {
        let shouldOpen = true;

        switch ( t ) {
            default:
                console.log( 'Unknown modal type: ' + t );
                shouldOpen = false;
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    const AccordionSummary = styled( ( props ) => (
        <MuiAccordionSummary expandIcon={<KeyboardArrowRightSharpIcon sx={{ fontSize: '0.9rem' }} />} {...props} />
    ) ) ( ( { theme } ) => ( {
        backgroundColor:
          theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
        flexDirection: 'row-reverse',
        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            transform: 'rotate(90deg)',
        },
        '& .MuiAccordionSummary-content': {
            marginLeft: theme.spacing(1),
        },
    } ) );

    return (
        <SectionV2 title={title} body={body} />
        // <Container fluid className='p-0'>
        //     <Accordion expanded={expanded}>
        //         <AccordionSummary expandIcon={<KeyboardArrowRightSharpIcon onClick={ () => setExpanded( !expanded ) } />}>
        //             <Row className='align-items-center w-100'>
        //                 <Col><Typography>{title}</Typography></Col>
        //             </Row>
        //         </AccordionSummary>
        //         <AccordionDetails>
        //             <ListGroup variant='flush' className='overflow-scroll' style={ { maxHeight: '400px' } }>
        //             { obj.notes.map( ( n, idx ) => (
        //                 <ListGroup.Item key={idx}>
        //                     <Row className='align-items-center'>
                                
        //                     </Row>
        //                 </ListGroup.Item>
        //             ) ) }
        //             </ListGroup>
        //         </AccordionDetails>
        //     </Accordion>
        // </Container>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email
} );

const mapDispatch = ( dispatch ) => ( {
} );

export default connect( mapProps, mapDispatch )( ObjFields );